
// ---- For debugging ------
import { debugInit } from '../../../SharedLibs/Debug.js';
var debug = debugInit("Progress");


export class Progress {

  /**
  * Constructor of the fileSet
  * @return {[type]}               [description]
  */
  constructor( data ) {
    debug.log(`Progress constructor : data`, data)
    this.data = {
      "_id" : data.object._id,
      "max" : undefined,
      "v" : undefined,
      "vBefore": 0,
      "on" : false,
      "cancellable": data.cancellable,
      "startAction" : undefined,
      "timeElapsed" : 0,
      "object": data.object,
      "hasEnded": false
    }

  }

  get on() { return this.data.on }

  get max() { return this.data.max }

  get startAction() { return this.data.startAction }

  get remainingTime() {
    let diff = Date.now() - this.data.startTime;
    return diff > 300 ? 0 : 300;
  }

  get remainingLastTime(){
    let diff = Date.now() - this.data.startTime;
    return diff > 300 ? 100 : 400;
  }

  get value() { return this.data.v }
  
  get percent() {
    if ( this.data.v === undefined ) return undefined;
    if ( this.data.max === undefined ) return undefined;
    let p = Math.floor( ( this.data.v * 100) / this.data.max );
    return p;
  }

  addChild(child){
    if (!child) return undefined
    if (!this.childs) this.childs = {}
    this.childs[child.data._id] = child
  }

  start( max ) {
    
    this.data.max = max;
    this.data.v = 0 ;
    this.data.on = true;
    debug.log(`Progress START >>> max= ${max}, this.data.max= ${this.data.max} this =>`, this)
    if ( this.parent ) {
      this.parent.startFromChild(max)
    }
    return true;
  }
  
  
  startFromChild(max){
    debug.log(`start from Child initialMax = ${this.data.max}`)
    if (!this.data.max) this.data.max = 0
    this.data.max += max
    if (!this.data.on) this.data.on = true
    if (!this.data.v) this.data.v = 0
    debug.log(`Progress START ${this.data._id} from child >>> ChildMax= ${max}, this.data.max= ${this.data.max} this =>`, this)
    if (this.parent) this.parent.startFromChild(max)
  }

  setProgressMax(max){
    this.data.max = max
  }


  abort() {
    //console.log(`aborting ${this.data._id} this.data.v = ${this.data.v}, this max = ${this.data.max}`)
    this.data.v = undefined;
    this.data.vBefore = 0;
    this.data.on = false;
    this.data.hasEnded = true;
    if ( this.data.max ) {
      this.data.max = undefined;
    }
    if(this.parent) this.parent.abortFromChild(this.data)
    return true;
  
  }

  abortFromChild(data){
    for (let childIndex in this.childs){
      if(this.childs[childIndex].data.on) return true
    }
    this.abort(data)
  }

  end() {
    this.data.v = undefined;
    this.data.vBefore = 0;
    this.data.on = false;
    this.data.hasEnded = true;
    if ( this.data.max ) {
      this.data.max = undefined;
    }
    if(this.parent) this.parent.abortFromChild(this.data)
    return true;
  }

  increment() {
    debug.log(`Progress increment > this.data.v `, this.data.v)
    debug.log(`Progress increment > this.data.max `, this.data.max)
    //this.data.vBefore = this.data.v
    this.data.v ++;
    this.data.startTime = Date.now();
    if ( this.data.v < this.data.max ) {
      if ( this.parent ) this.parent.updateFromChild(this.data)
    }
    return true;
  }

  updateFromChild(childData){
    debug.log(`Progress ${this.data.object._id} updateFromChild > this.data.v `, this.data.v)
    debug.log(`Progress ${this.data.object._id} updateFromChild > this.data.max `, this.data.max)

    this.data.on = childData.on
    //this.data.vBefore = this.data.v
    this.data.v ++
    this.data.cancellable = childData.cancellable
    if (this.parent) this.parent.updateFromChild(this.data)
  }

  getParents(parents=[]){
    if (!this.parent) return parents
    parents.push(this.parent)
    if(this.parent.parent) this.parent.getParents(parents)
    return parents
  }

  removeFromParentChilds(_id){
    if (!this.parent) return true
    if (!this.parent.childs[_id]) return true
    if (this.parent) delete (this.parent.childs[_id])
  }


  /* 
  childAbort( _id ) {
    let child = this.childs[_id];
    if ( child ) {
      if ( this.data.v >= this.data.max ) this.data.v = this.data.max
      delete ( this.childs[_id] );
    }

    // ---- If no childs... close it too
    let childRunning = false;
    for ( let childId in this.childs ) {
      if ( this.childs[childId].on ) childRunning=true;
    }
    if ( childRunning === false ) this.abort();
  } */





}
